import React, { useState, useEffect } from 'react';
import {
  makeStyles,
  DialogContent,
  Grid,
  TextField,
  DialogActions,
  Button,
} from '@material-ui/core';
import { DialogCreateIdea, DialogCustomTitle, dialogCss } from '../CreateIdeaDialogs';
import { MenuInformation } from '../Shared';
import clsx from 'clsx';
import { useWindowSize } from '../../hooks';
import { ideaUpdateActions } from '../../actions';
import { useForm } from 'react-hook-form';
import config from '../../config';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  dividerBottom: {
    borderBottom: 'none',
  },
  title: {
    fontSize: 16,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  button: {
    textTransform: 'lowercase',
  },
  grid: {
    position: 'relative',
  },
  buttonInformation: {
    position: 'absolute',
    top: 12,
    right: 12,
    zIndex: 9999,
  },
  buttonBottom: {
    top: 242,
  },
}));

function ValueCanvasEdit({ idea, isOpen, onClose }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const dialogClasses = dialogCss();
  const classes = useStyles();
  const [width] = useWindowSize();

  const { handleSubmit, getValues, register } = useForm({
    mode: 'onBlur',
    defaultValues: {
      canvas: idea.canvasValueProposition,
    }
  });

  function onSubmit(data) {
    dispatch(ideaUpdateActions.updateCanvasValue(data));
    onClose();
  };

  function handleBlur() {
    dispatch(ideaUpdateActions.updateCanvasValue(getValues()));
  }

  return (
    <DialogCreateIdea maxWidth="lg" open={isOpen}>
      <DialogCustomTitle id="customized-dialog-title" onClose={onClose}>
        canvas
      </DialogCustomTitle>
      <DialogContent dividers className={classes.dividerBottom}>
              <Grid container justifyContent="center" spacing={2} padding={10}>
          <Grid item xs={12} md className={classes.grid}>
            <div className={classes.buttonInformation}>
              <MenuInformation>
                Nesse ponto descreva de forma sucinta as melhores soluções do seu produto e aposte também emm elaborar um MVP(Produto Mínimo Viável), que consistem em um produto com o mínimo de recursos possível, mas que serve para conhecer a reação do mercado sobre a sua viabilidade. 

              </MenuInformation>
            </div>
            <TextField
              name="Q1"
              id="Q1"
              variant="filled"
              label="produtos e serviços"
              multiline
              fullWidth
              placeholder="Qual produto ou serviço será oferecido ao cliente?"
              style={{ marginBottom: 16 }}
              minRows={width > config.RESPONSIVE_MOBILE ? 8 : 8}
              maxRows={width > config.RESPONSIVE_MOBILE ? 8 : 8}
              InputLabelProps={{
                shrink: true,
                style: { fontSize: 16, fontWeight: 'bold' },
              }}
              InputProps={{
                disableUnderline: true,
                style: {
                  padding: '34px 12px 5px',
                },
              }}
              inputRef={register}
              onBlur={handleBlur}
              defaultValue={idea.canvasValueProposition[0]?.answer}
            />

            <div
              className={clsx(classes.buttonInformation, classes.buttonBottom)}
            >
              <MenuInformation>
                 Defina as principais ações e pontos que darão suporte e aliviarão as principais dores dos clientes.
                
              </MenuInformation>
            </div>
            <TextField
              name="Q2"
              id="Q2"
              variant="filled"
              label="analgésicos"
              multiline
              fullWidth
              minRows={width > config.RESPONSIVE_MOBILE ? 8 : 8}
              maxRows={width > config.RESPONSIVE_MOBILE ? 8 : 8}
              placeholder="Como sua ideia de produto alivia as principais dores dos clientes?"
              InputLabelProps={{
                shrink: true,
                style: { fontSize: 16, fontWeight: 'bold' },
              }}
              InputProps={{
                disableUnderline: true,
                style: {
                  padding: '34px 12px 5px',
                },
              }}
              inputRef={register}
              onBlur={handleBlur}
              defaultValue={idea.canvasValueProposition[1]?.answer}
            />
          </Grid>
          <Grid item xs={12} md className={classes.grid}>
            <div className={classes.buttonInformation}>
              <MenuInformation>
                Faça uma lista dos três principais benefícios aos clientes.Esse é o momento de avaliar o que ajudaria os seus clientes em potencial e quais benefícios que a sua empresa se propõe a fazer.

              </MenuInformation>
            </div>

            <TextField
              name="Q3"
              id="Q3"
              variant="filled"
              label="criadores de ganhos"
              multiline
              fullWidth
              minRows={width > config.RESPONSIVE_MOBILE ? 19 : 8}
              maxRows={width > config.RESPONSIVE_MOBILE ? 19 : 8}
              placeholder="Quais elementos da sua ideia que trarão benefícios aos clientes?"
              InputLabelProps={{
                shrink: true,
                style: { fontSize: 16, fontWeight: 'bold' },
              }}
              InputProps={{
                disableUnderline: true,
                style: {
                  padding: '34px 12px 10px',
                },
              }}
              inputRef={register}
              onBlur={handleBlur}
              defaultValue={idea.canvasValueProposition[2]?.answer}
            />
          </Grid>
          
           
          <Grid item xs={12} md className={classes.grid}>
            <div className={classes.buttonInformation}>
              <MenuInformation>
                É aqui que você precisa concertar sua energia para pensar no grande diferencial da sua ideia, quais são seus ganhos necessários, esperados, desejados e inesperados que irá trazer inovação para o mercado que está inserido.

              </MenuInformation>
            </div>
            <TextField
              name="Q4"
              id="Q4"
              variant="filled"
              label="ganhos"
              multiline
              fullWidth
              minRows={width > config.RESPONSIVE_MOBILE ? 8 : 8}
              maxRows={width > config.RESPONSIVE_MOBILE ? 8 : 8}
              placeholder="Quais são os maiores ganhos da sua ideia para seu cliente?"
              style={{ marginBottom: 16 }}
              InputLabelProps={{
                shrink: true,
                style: { fontSize: 16, fontWeight: 'bold' },
              }}
              InputProps={{
                disableUnderline: true,
                style: {
                  padding: '34px 12px 5px',
                },
              }}
              inputRef={register}
              onBlur={handleBlur}
              defaultValue={idea.canvasValueProposition[3]?.answer}
            />

            <div
              className={clsx(classes.buttonInformation, classes.buttonBottom)}
            >
              <MenuInformation>
                   É hora de identificar quais são as principais dificuldades desse cliente pensar em como o seu produto ou serviço poderão solucionar esses problemas.

              </MenuInformation>
            </div>
            <TextField
              name="Q5"
              id="Q5"
              variant="filled"
              label="dores"
              multiline
              fullWidth
              minRows={width > config.RESPONSIVE_MOBILE ? 8 : 8}
              maxRows={width > config.RESPONSIVE_MOBILE ? 8 : 8}
              placeholder="Quais são as maiores dores do seus cliente?"
              InputLabelProps={{
                shrink: true,
                style: { fontSize: 16, fontWeight: 'bold' },
              }}
              InputProps={{
                disableUnderline: true,
                style: {
                  padding: '34px 12px 5px',
                },
              }}
              inputRef={register}
              onBlur={handleBlur}
              defaultValue={idea.canvasValueProposition[4]?.answer}
            />
          </Grid>
          <Grid item xs={12} md className={classes.grid}>
            <div className={classes.buttonInformation}>
              <MenuInformation>
                    Organize em uma lista tudo o que os clientes precisam realizar.Todas as tarefas que precisam executar no dia a dia. Caso Identifique que existe mais de um tipo de cliente, o ideal é executar um quadro para cada um deles.

              </MenuInformation>
            </div>
            <TextField
              name="Q6"
              id="Q6"
              variant="filled"
              label="tarefa dos clientes"
              multiline
              fullWidth
              minRows={width > config.RESPONSIVE_MOBILE ? 19 : 8}
              maxRows={width > config.RESPONSIVE_MOBILE ? 19 : 8}
              placeholder="Quais são as tarefas funcionais que os clientes precisam realizar?"
              InputLabelProps={{
                shrink: true,
                style: { fontSize: 16, fontWeight: 'bold' },
              }}
              InputProps={{
                disableUnderline: true,
                style: {
                  padding: '34px 12px 10px',
                },
              }}
              inputRef={register}
              onBlur={handleBlur}
              defaultValue={idea.canvasValueProposition[5]?.answer}
            />
          </Grid>
        </Grid>
        <Grid container justifyContent="center" spacing={2}>
          <Grid item xs={12} md={6} className={classes.grid}  >
            <Grid container justifyContent="center" spacing={2}>

              <Grid item xs={12} md={6} className={classes.grid}>
                <div className={classes.buttonInformation}>
                  <MenuInformation>
                    Escolha um nome que passe o objetivo de maneira simples o acessível.

                  </MenuInformation>
                </div>
                <TextField
                  name="Q7"
                  id="Q7"
                  variant="filled"
                  label="Nome do Produto"
                  multiline 
                  fullWidth

                  minRows={width > config.RESPONSIVE_MOBILE ? 4 : 8}
                  maxRows={width > config.RESPONSIVE_MOBILE ? 4 : 8}
                  placeholder="Qual é o nome da solução que a sua ideia traz ?"
                  InputLabelProps={{
                    shrink: true,
                    style: { fontSize: 16, fontWeight: 'bold' },
                  }}
                  InputProps={{
                    disableUnderline: true,
                    style: {
                      padding: '34px 12px 10px',
                    },
                  }}
                  inputRef={register}
              onBlur={handleBlur}
                  defaultValue={idea.canvasValueProposition[6]?.answer}
                />

              </Grid>
              <Grid item xs={12} md={6} className={classes.grid}  >
                <div className={classes.buttonInformation}>
                  <MenuInformation>
                Descreva como seria seu cliente ideal.

                  </MenuInformation>
                </div>
                <TextField
                  name="Q8"
                  id="Q8"
                  variant="filled"
                  label="cliente ideal"
                  multiline 
                  fullWidth

                  minRows={width > config.RESPONSIVE_MOBILE ? 4 : 8}
                  maxRows={width > config.RESPONSIVE_MOBILE ? 4 : 8}
                  placeholder="Qual seria o cliente ideal para sua ideia?"
                  InputLabelProps={{
                    shrink: true,
                    style: { fontSize: 16, fontWeight: 'bold' },
                  }}
                  InputProps={{
                    disableUnderline: true,
                    style: {
                      padding: '34px 12px 10px',
                    },
                  }}
                  inputRef={register}
              onBlur={handleBlur}
                  defaultValue={idea.canvasValueProposition[7]?.answer}
                />

              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={6} className={classes.grid}>
            <div className={classes.buttonInformation}>
              <MenuInformation>
Faça uma pesquisa com os principais adversários no mercado e veja como eles abordam o problema que sua ideia pretende resolver.

              </MenuInformation>
            </div>
            <TextField
              name="Q9"
              id="Q9"
              variant="filled"
              label="concorrentes ou substitutos"
              multiline
              fullWidth
              minRows={width > config.RESPONSIVE_MOBILE ? 4 : 8}
              maxRows={width > config.RESPONSIVE_MOBILE ? 4 : 8}
              placeholder="Quais são os principais concorrentes da sua ideia atuando no mercado?"
              InputLabelProps={{
                shrink: true,
                style: { fontSize: 16, fontWeight: 'bold' },
              }}
              InputProps={{
                disableUnderline: true,
                style: {
                  padding: '34px 12px 10px',
                },
              }}
              inputRef={register}
              onBlur={handleBlur}
              defaultValue={idea.canvasValueProposition[8]?.answer}
            />
          </Grid>
        </Grid>
      </DialogContent>
            <DialogActions className={dialogClasses.containerAction}>
        <div style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
        }}>
          <div>
            <Button
              color="primary"
              onClick={onClose}
              startIcon={<ArrowBackIcon />}
              className={dialogClasses.button}
            >
              {t('voltar')}
            </Button>
          </div>
          <div>
            <Button
              className={dialogClasses.button}
              variant="contained"
              type="submit"
              color="primary"
              endIcon={<ArrowForwardIcon />}
              onClick={handleSubmit(onSubmit)}
            >
              {t('avancar')}
            </Button>
          </div>
        </div>
      </DialogActions>
    </DialogCreateIdea>
  );
}

export { ValueCanvasEdit };
